<template>
  <v-dialog v-model="dialog" persistent width="750">
    <v-card>
      <!-- Cabecera del formulario -->

      <v-toolbar color="#7e5ec2">
        <span class="material-symbols-outlined"> </span>
        <p class="tituloCard">Rechazar reprogramación</p>
        <v-spacer></v-spacer>
        <v-btn icon @click="close()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>

      <!-- Cuerpo del formulario -->
      <v-form @submit.prevent="save" v-model="valid" ref="form" lazy-validation>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <h4 class="texto">
                  <strong class="titulo">Número:</strong> {{ this.form.numero }}
                </h4>
              </v-flex>
              <v-flex xs12>
                <h4 class="texto">
                  <strong class="titulo">Nombre:</strong>
                  {{ this.form.nombres }}
                </h4>
              </v-flex>
              <v-flex xs12>
                <h4 class="texto">
                  <strong class="titulo">Cedula:</strong>
                  {{ this.form.nro_doc }}
                </h4>
              </v-flex>

              <v-flex xs12>
                <h4 class="subtitulo">
                  <strong>{{ subtitulo_detalle }}</strong>
                </h4>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex xs12>
                <v-data-table
                  :items="lista_papeleta"
                  class="elevation-1"
                  hide-actions
                  :headers="headers"
                >
                  <template v-slot:items="props">
                    <td class="text-xs-center">{{ props.item.fecha_desde }}</td>
                    <td class="text-xs-center">{{ props.item.fecha_hasta }}</td>

                    <td class="text-xs-center">{{ props.item.dias }}</td>
                    <td class="text-xs-center">{{ props.item.estado }}</td>
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
            <v-flex xs12 v-if="lista_reprogramaciones.length>0 && (form.tipo == 'FR' || form.tipo=='R')">
              <h4><strong>Detalle de reprogramación de vacación</strong></h4>
            </v-flex>
            <v-layout>
              <v-flex xs12>
                <v-data-table
                  v-if="lista_reprogramaciones.length>0 && (form.tipo == 'FR' || form.tipo=='R')"
                  :items="lista_reprogramaciones"
                  class="elevation-1"
                  hide-actions
                  :headers="headers_reprogramaciones"
                >
                  <template v-slot:items="props">
                    <td class="text-xs-center">{{ props.item.secuencia }}</td>
                    <td class="text-xs-center">{{ props.item.fecha_desde }}</td>
                    <td class="text-xs-center">{{ props.item.fecha_hasta }}</td>

                    <td class="text-xs-center">{{ props.item.total_dias }}</td>
                    <td class="text-xs-center">{{ props.item.estado }}</td>
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
            <v-flex xs12>
              <h4 class="subtitulo">
                <strong>{{ subtitulo_seguimiento }}</strong>
              </h4>
            </v-flex>
            <v-layout>
              <v-flex xs12>
                <v-data-table
                  :items="lista_detalle"
                  class="elevation-1"
                  hide-actions
                  :headers="headers2"
                >
                  <template v-slot:items="props">
                    <td class="text-xs-center">
                      {{ props.item.fecha_registro }}
                    </td>
                    <td class="text-xs-center">{{ props.item.estado }}</td>
                    <td class="text-xs-center">{{ props.item.usuario }}</td>
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
            <v-layout wrap>
              <v-flex md12>
                <v-textarea
                  v-model="form.motivo_rechazo"
                  class="v_card"
                  rows="2"
                  label="Justificación del rechazo"
                  background-color="rgba( 117, 109, 194 ,0.4)"
                  :rules="$validate(['required'])"
                  required
                  outline
                  success
                  clearable
                >
                </v-textarea>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click.native="close()">
            <v-icon>cancel</v-icon> {{ $t("common.cancel") }}
          </v-btn>
          <v-btn
            color="rgba(14, 187, 178, 0.6)"
            @click.prevent="rechazarReprogramacion()"
            ><v-icon>done</v-icon>
            Rechazar reprogramación
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>
  
  <script>
import validate from "@/common/mixins/validate"; // Importación de mixin de validaciones

export default {
  // Definición de mixins importados
  mixins: [validate],
  // Variables iniciales
  data() {
    return {
      dialog: false,

      form: {
        funcionario: {
          nombre: "",
          motivo_rechazo: null,
        },
      },
      //url: 'vCronoVacass',
      valid: false,
      loading: false,
      estado_vacacion: [],
      nombre: null,
      fecha_ingreso: null,
      fecha_desde: "",
      fecha_hasta: "",
      persona: null,
      saldo: null,
      periodo: null,
      lista_reprogramaciones:[],
      id: null,
      subtitulo_detalle: "Detalle de vacación programada",
      subtitulo_seguimiento: "Seguimiento de vacación programada",
      lista_papeleta: [],
      lista_detalle: [],
      headers: [
        { text: "Fecha salida", sortable: false, align: "center" },
        { text: "Fecha fin", sortable: false, align: "center" },

        { text: "Dias", sortable: false, align: "center" },
        { text: "Estado", sortable: false, align: "center" },
      ],
      headers2: [
        { text: "Fecha registro", sortable: false, align: "center" },
        { text: "Estado", sortable: false, align: "center" },
        { text: "Usuario", sortable: false, align: "center" },
        { text: "Solicitud enviada a:", sortable: false, align: "center" },
      ],
      headers_reprogramaciones: [
        { text: "Nro", sortable: false, align: "center" },
        { text: "Fecha desde", sortable: false, align: "center" },
        { text: "Fecha hasta", sortable: false, align: "center" },
        { text: "Dias", sortable: false, align: "center" },
        { text: "Estado", sortable: false, align: "center" },
      ],
    };
  },
  async mounted() {
    this.$bus.$on("openDialogRechazarReprogramacionJefe", async (item) => {
      this.form = item;
      if (this.form.tipo == "FR") {
        await this.cargarReprogramaciones();
        this.titulo = "Ver reprogramación de vacaciones";
        this.subtitulo_detalle =
          "Detalle de vacación programada a ser reprogramada";
        this.subtitulo_seguimiento =
          "Seguimiento de reprogramación de vacación";
      }
      if (this.form.tipo == "R") {
        await this.cargarReprogramaciones();
        this.titulo = "Ver reprogramación de vacación";
        this.subtitulo_detalle = "Detalle de vacación reprogramada";
        this.subtitulo_seguimiento = "Seguimiento de vacación reprogramada";
      }
      this.form.id = parseInt(this.form.id);
      this.cargarTablaPapeleta();
      this.dialog = true;
      await this.cargarSeguimiento();
    });
  },

  methods: {
    close() {
      this.form = {
        funcionario: {
          nombre: "",
        },
      };
      this.lista_papeleta = [];
      this.loading = false;
      this.valid = false;
      this.$bus.$emit("closeDialogRechazarReprogramacionJefe");
      this.dialog = false;
    },
    cargarTablaPapeleta() {
      const elemento = {
        fecha_desde: this.form.fecha_desde,
        fecha_hasta: this.form.fecha_hasta,
        dias: this.form.dias,
        estado: this.form.estado,
      };
      this.lista_papeleta.push(elemento);
    },
    async cargarSeguimiento() {
      try {
        let respuesta = await this.$service.graphql({
          query: `
              query{
                  runQuery(consulta:"select * from vacaciones.v_seguimiento_vaca_progra vsvp  where vsvp.id_vaca_progra =${parseInt(
                    this.form.id_vacacion
                  )}"){
                      respuesta
                  }
                  }
              `,
        });
        respuesta = respuesta.runQuery.respuesta;
        let lista_seguimiento = [];
        if (this.form.tipo == "P") {
          respuesta.forEach((element) => {
            let elemento = element;
            if (
              elemento.id_estado != 22 &&
              elemento.id_estado != 54 &&
              elemento.id_estado != 51 &&
              elemento.id_estado != 66 &&
              elemento.id_estado != 74 &&
              elemento.id_estado != 73 &&
              elemento.id_estado != 72
            ) {
              lista_seguimiento.push(elemento);
            }
          });
          this.lista_detalle = lista_seguimiento;
        } else {
          this.lista_detalle = respuesta;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async cargarReprogramaciones() {
      try {
        let respuesta = await this.$service.graphql({
          query: `
              query{
                  runQuery(consulta:"select * from vacaciones.v_vacaciones_reprogramadas vsvp where vsvp.id_padre =${this.form.id_vacacion}"){
                      respuesta
                  }
                  }
              `,
        });
        if (respuesta.runQuery.respuesta.length > 0) {
          respuesta = respuesta.runQuery.respuesta;
          this.lista_reprogramaciones = respuesta;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async rechazarReprogramacion() {
      if (this.form.motivo_rechazo == null || !this.form.motivo_rechazo) {
        return;
      }
      let respuesta;
      let resps = [];
      let correcto;
      let user = this.$storage.get("user");

      this.loading = true;
      try {
        respuesta = await this.$service.graphql({
          query: `
                                       query{
                                        runQuery(consulta:"select vacaciones.fn_rechazo_reprogramacion(${parseInt(
                                          this.form.id_vacacion
                                        )},${user.id_persona},${user.id},'${
            this.form.motivo_rechazo
          }')"){
                                          respuesta
                                        }
                                      }
                                  `,
        });
        respuesta = respuesta.runQuery.respuesta[0].fn_rechazo_reprogramacion;
        resps = respuesta.split("|");
        correcto = resps[0];

        if (correcto === "1") {
          this.$confirm("La reprogramación fué rechazada", () => {
            this.loading = false;
            this.close();
          });
        } else {
          this.$confirm(resps[1], () => {
            this.loading = false;
          });
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
  
  <style>
.titulo {
  font-size: 1.07em;
  color: rgb(20, 7, 84);
  font-weight: bold;
}
.texto {
  font-size: 1.07em;
  color: rgb(20, 7, 84);
}
.subtitulo {
  font-size: 1.35em;
  color: rgb(20, 7, 84);
  font-weight: bolder;
  font-family: Impact, Haettenschweiler, "Arial Narrow Bold", sans-serif;
}
.cabecera {
  background-color: rgba(20, 7, 84, 0.35);
  font-size: 1.5em;
  color: rgba(20, 7, 841);
  font-weight: bolder;
}
</style>
  
  
  


// WEBPACK FOOTER //
// src/components/admin/vacacion_uso/dialogs/RechazarReprogramacionJefe.vue